import * as React from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { SelectionFieldItem } from '../../types-fields';
import { DragItem, ItemTypes } from 'app/area/reports/types';

interface SortItemComponentProps {
  field: SelectionFieldItem;
  connectDragSource?: any;
  connectDropTarget?: any;
  findField: (item: SelectionFieldItem) => number;
  moveField: (droppedId: number, originalIndex: number) => void;
  children?: React.ReactNode;
}

const SortItemComponent: React.FC<SortItemComponentProps> = ({
  children, field, moveField, findField
}) => {
  
  const ref = React.useRef<HTMLDivElement>(null);

  const [{}, drag] = useDrag({
    item: { field },
    type: ItemTypes.GROUPBY_SORT,
    collect: (monitor) => {
      return {
        isDragging: monitor.isDragging()
      };
    }
  });

  const [{ isHover }, drop] = useDrop({
    accept: ItemTypes.GROUPBY_SORT,
    drop: (item, monitor) => {
      const itemField = (monitor.getItem() as DragItem).field;
      const index = findField(itemField);
      const overId = findField(field);
      if (index !== overId) {
        moveField(index, overId);
      }
    },
    collect: (monitor) => ({
      isHover: monitor.isOver({ shallow: true })
    })
  });
  
  const opacity = isHover ? 0.5 : 1;

  drag(drop(ref));

  return <div ref={ref} style={{ opacity }}>
      {children}  
    </div>;
};

export const SortItem = SortItemComponent;
